package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageOptimizer
import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.model.ImageData
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.repository.InventoryRepository
import fr.manyverse.app.domain.validation.ImageValidator

class UploadInventoryItemImageUseCase(
    private val imageStorageRepository: ImageStorageRepository,
    private val inventoryRepository: InventoryRepository,
    private val imageOptimizer: ImageOptimizer
) {
    suspend operator fun invoke(
        characterId: String,
        itemId: String,
        imageData: ImageData
    ): Result<String> {
        ImageValidator.validate(imageData).onFailure {
            return Result.failure(it)
        }

        val optimized = imageOptimizer.optimize(imageData).getOrElse {
            return Result.failure(it)
        }

        val uploadResult = imageStorageRepository.upload(ImageTarget.InventoryItem(characterId, itemId), optimized)
        if (uploadResult.isFailure) return uploadResult

        val imagePath = uploadResult.getOrThrow()
        inventoryRepository.updateImageUrl(itemId, imagePath)
        return Result.success(imagePath)
    }
}
